import { Box, Grid } from '@mui/material'
import SectionHeader from 'components/Common/SectionHeader'
import Form from 'components/RouteWizard/Form'
import Input from 'components/RouteWizard/Input'
import { useRef, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
// import { useDispatch } from 'react-redux'
import { authAPI } from 'api/authAPI'
import { useHistory, useLocation } from 'react-router-dom'
import Card from '../../materialUI/components/Card/Card'
import CardBody from '../../materialUI/components/Card/CardBody'
import { container } from '../../materialUI/jss/material-dashboard-pro-react'
import styles from './registerPageStyle'
import schema from './schema'

export default function RegisterPage() {
  const history = useHistory()
  const formMethods = useRef<UseFormReturn | null>(null)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleSubmit = async (data: any) => {
    setIsLoading(true)
    const payload = {
      email: queryParams.get('email') || '',
      password: data.newPassword,
      confirmPassword: data.newPasswordConf,
      inviteReference: queryParams.get('inviteReference') || '',
      userId: queryParams.get('userId') || '',
    }

    await authAPI.completeRegistration(payload)

    history.replace('/auth/login')
  }

  return (
    <Box component={'div'} sx={[container, styles.container]}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12} md={10}>
          <Card sx={styles.cardSignup}>
            <CardBody>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={8} md={5}>
                  <SectionHeader
                    title="Set Your Password"
                    subtitle={
                      <Box>
                        Password Criteria:
                        <ul>
                          <li>must be at least 8 characters</li>
                          <li>contain one number</li>
                          <li>contain one lowercase letter</li>
                          <li>contain one uppercase letter</li>
                          <li>contain one special character</li>
                        </ul>
                      </Box>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={8} md={5}>
                  <Form
                    defaultValues={{}}
                    schema={schema}
                    isLoading={isLoading}
                    ref={formMethods}
                    onSubmit={handleSubmit}
                    submitText="Set Password"
                  >
                    <Input
                      name="newPassword"
                      label="New Password"
                      type={'password'}
                    />
                    <Input
                      name="newPasswordConf"
                      label="New Password Confirmation"
                      type={'password'}
                    />
                  </Form>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
